import { useState, useEffect, useMemo } from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch } from 'react-redux'
import { useAuth, useUser, utils } from '@chordcommerce/gatsby-theme-autonomy'
import useNotificationAlertBarQuery from '~/hooks/graphql/queries/use-notification-alert-bar'
import * as actions from '~/redux/actions/alert-bar'
import { toUsdCurrency } from '~/utils/formatters'

const useNotificationAlertBar = () => {
  const { getParam } = utils
  const { isLoggedIn } = useAuth()
  const dispatch = useDispatch()
  const [notification, setNotification] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const { user } = useUser()

  const storeCredit =
    user?.data?.storeCredit && parseFloat(user.data.storeCredit)

  const dismissAlertBar = useMemo(
    () => bindActionCreators(actions.dismissAlertBar, dispatch),
    [dispatch]
  )

  const updateAlertBar = useMemo(
    () => bindActionCreators(actions.updateAlertBar, dispatch),
    [dispatch]
  )

  const {
    affiliateNotification,
    notificationAlertBar,
    promoNotification,
    referralNotification,
    storeCreditNotification,
  } = useNotificationAlertBarQuery()

  useEffect(() => {
    setLoaded(true)

    // @todo Deprecate aff due to collisions with Goaffpro attribution.
    if (!!getParam('mwaff') || !!getParam('aff')) {
      setNotification(affiliateNotification)
    } else if (!!getParam('promo')) {
      setNotification(promoNotification)
    } else if (!!getParam('ref')) {
      setNotification(referralNotification)
    } else if (isLoggedIn && storeCredit && storeCreditNotification) {
      setNotification({
        ...storeCreditNotification,
        description: {
          childMarkdownRemark: {
            html: storeCreditNotification.description.childMarkdownRemark.html.replace(
              '{{amount}}',
              toUsdCurrency(storeCredit)
            ),
          },
        },
      })
    } else if (notificationAlertBar?.notification) {
      setNotification(notificationAlertBar.notification)
    } else {
      setNotification(null)
    }
  }, [
    affiliateNotification,
    isLoggedIn,
    notificationAlertBar,
    promoNotification,
    referralNotification,
    setLoaded,
    setNotification,
    storeCreditNotification,
    storeCredit,
    getParam,
  ])

  return { loaded, notification, dismissAlertBar, updateAlertBar }
}

export default useNotificationAlertBar
